import React from 'react'
import { TooltipLabelWithoutIcon } from 'components/TooltipLabelWithoutIcon'
import { Button } from 'semantic-ui-react'

export const LimitFeatureButton = ({
  featureLimit,
  usageCount,
  descriptionTitle,
  descriptionContent,
  learnMoreLink,
  buttonText,
  handleClick,
  loading,
  isAllowedFeature = true,
  ref = null,
}) => {
  const allowUseFeatureButton = featureLimit ? parseInt(featureLimit) > parseInt(usageCount) : true

  //isAllowedFeatured is used to support feature that has plan restriction, but no usage limit
  if (isAllowedFeature && allowUseFeatureButton) {
    return (
      <span>
        <Button ref={ref} primary disabled={loading} loading={loading} onClick={handleClick}>
          <i className="icon far fa-plus" />
          {buttonText}
        </Button>
      </span>
    )
  } else {
    return (
      <TooltipLabelWithoutIcon
        descriptionTitle={descriptionTitle}
        descriptionContent={descriptionContent}
        showGotoBillingPage={true}
        trigger={
          <span>
            <Button primary disabled>
              <i className="icon far fa-plus" />
              {buttonText}
            </Button>
          </span>
        }
        learnMoreLink={learnMoreLink}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/LimitFeatureButton/index.js